var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_36517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2652 17.0547C32.2652 8.16978 25.2383 0.967163 16.5701 0.967163C7.90195 0.967163 0.875 8.16978 0.875 17.0547C0.875 25.9395 7.90195 33.1422 16.5701 33.1422C25.2383 33.1422 32.2652 25.9395 32.2652 17.0547Z",
    fill: "#ECECF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6 12.0547H11.4C10.6268 12.0547 10 12.6143 10 13.3047V20.8047C10 21.495 10.6268 22.0547 11.4 22.0547H22.6C23.3732 22.0547 24 21.495 24 20.8047V13.3047C24 12.6143 23.3732 12.0547 22.6 12.0547Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13.7213L17.721 17.6823C17.5049 17.8167 17.255 17.888 17 17.888C16.745 17.888 16.4951 17.8167 16.279 17.6823L10 13.7213",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_36517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.0703125 0.554688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.0710b27094b7a2465f3b5a441a97c5eb.svg";
export { ForwardRef as ReactComponent };